import React from 'react';
import TotalsCard from '../totals/TotalsCard';
import { useGetOrdersTotalsConfig } from './hooks';
import { OrdersTotalsProps } from './types';

const OrdersTotals: React.FC<OrdersTotalsProps> = (props) => {
  const { 'data-testid': dataTestId } = props;
  const config = useGetOrdersTotalsConfig();
  return (
    <div data-testid={dataTestId}>
      <TotalsCard {...config} data-testid={`${dataTestId}-totals-card`} />
    </div>
  );
};

export default OrdersTotals;
